"use strict";
exports.__esModule = true;
exports.schoolDistricts = void 0;
var schoolDistricts = [
    { id: 1, name: 'Aberdeen' },
    { id: 2, name: 'Adna' },
    { id: 3, name: 'Almira' },
    { id: 4, name: 'Anacortes' },
    { id: 5, name: 'Arlington' },
    { id: 6, name: 'Asotin-Anatone' },
    { id: 7, name: 'Auburn' },
    { id: 8, name: 'Bainbridge Island' },
    { id: 9, name: 'Battle Ground' },
    { id: 10, name: 'Bellevue' },
    { id: 11, name: 'Bellingham' },
    { id: 12, name: 'Benge' },
    { id: 13, name: 'Bethel' },
    { id: 14, name: 'Bickleton' },
    { id: 15, name: 'Blaine' },
    { id: 16, name: 'Boistfort' },
    { id: 17, name: 'Bremerton' },
    { id: 18, name: 'Brewster' },
    { id: 19, name: 'Bridgeport' },
    { id: 20, name: 'Brinnon' },
    { id: 21, name: 'Burlington-Edison' },
    { id: 22, name: 'Camas' },
    { id: 23, name: 'Cape Flattery' },
    { id: 24, name: 'Carbonado' },
    { id: 25, name: 'Cascade' },
    { id: 26, name: 'Cashmere' },
    { id: 27, name: 'Castle Rock' },
    { id: 28, name: 'Centerville' },
    { id: 29, name: 'Central Kitsap' },
    { id: 30, name: 'Central Valley' },
    { id: 31, name: 'Centralia' },
    { id: 32, name: 'Chehalis' },
    { id: 33, name: 'Cheney' },
    { id: 34, name: 'Chewelah' },
    { id: 35, name: 'Chimacum' },
    { id: 36, name: 'Clarkston' },
    { id: 37, name: 'Cle Elum-Roslyn' },
    { id: 38, name: 'Clover Park' },
    { id: 39, name: 'Colfax' },
    { id: 40, name: 'College Place' },
    { id: 41, name: 'Colton' },
    { id: 42, name: 'Columbia (Stevens)' },
    { id: 43, name: 'Columbia (Walla Walla)' },
    { id: 44, name: 'Colville' },
    { id: 45, name: 'Concrete' },
    { id: 46, name: 'Conway' },
    { id: 47, name: 'Cosmopolis' },
    { id: 48, name: 'Coulee-Hartline' },
    { id: 49, name: 'Coupeville' },
    { id: 50, name: 'Crescent' },
    { id: 51, name: 'Creston' },
    { id: 52, name: 'Curlew' },
    { id: 53, name: 'Cusick' },
    { id: 54, name: 'Damman' },
    { id: 55, name: 'Darrington' },
    { id: 56, name: 'Davenport' },
    { id: 57, name: 'Dayton' },
    { id: 58, name: 'Deer Park' },
    { id: 59, name: 'Dieringer' },
    { id: 60, name: 'Dixie' },
    { id: 61, name: 'East Valley (Spokane)' },
    { id: 62, name: 'East Valley (Yakima)' },
    { id: 63, name: 'Eastmont' },
    { id: 64, name: 'Easton' },
    { id: 65, name: 'Eatonville' },
    { id: 66, name: 'Edmonds' },
    { id: 67, name: 'Ellensburg' },
    { id: 68, name: 'Elma' },
    { id: 69, name: 'Endicott' },
    { id: 70, name: 'Entiat' },
    { id: 71, name: 'Enumclaw' },
    { id: 72, name: 'Ephrata' },
    { id: 73, name: 'Evaline' },
    { id: 74, name: 'Everett' },
    { id: 75, name: 'Evergreen (Clark)' },
    { id: 76, name: 'Evergreen (Stevens)' },
    { id: 77, name: 'Federal Way' },
    { id: 78, name: 'Ferndale' },
    { id: 79, name: 'Fife' },
    { id: 80, name: 'Finley' },
    { id: 81, name: 'Franklin Pierce' },
    { id: 82, name: 'Freeman' },
    { id: 83, name: 'Garfield' },
    { id: 84, name: 'Glenwood' },
    { id: 85, name: 'Goldendale' },
    { id: 86, name: 'Grand Coulee Dam' },
    { id: 87, name: 'Grandview' },
    { id: 88, name: 'Granger' },
    { id: 89, name: 'Granite Falls' },
    { id: 90, name: 'Grapeview' },
    { id: 91, name: 'Great Northern' },
    { id: 92, name: 'Green Mountain' },
    { id: 93, name: 'Griffin' },
    { id: 94, name: 'Harrington' },
    { id: 95, name: 'Highland' },
    { id: 96, name: 'Highline' },
    { id: 97, name: 'Hockinson' },
    { id: 98, name: 'Hood Canal' },
    { id: 99, name: 'Hoquiam' },
    { id: 100, name: 'Inchelium' },
    { id: 101, name: 'Index' },
    { id: 102, name: 'Issaquah' },
    { id: 103, name: 'Kahlotus' },
    { id: 104, name: 'Kalama' },
    { id: 105, name: 'Keller' },
    { id: 106, name: 'Kelso' },
    { id: 107, name: 'Kennewick' },
    { id: 108, name: 'Kent' },
    { id: 109, name: 'Kettle Falls' },
    { id: 110, name: 'Kiona-Benton City' },
    { id: 111, name: 'Kittitas' },
    { id: 112, name: 'Klickitat' },
    { id: 113, name: 'La Center' },
    { id: 114, name: 'La Conner' },
    { id: 115, name: 'LaCrosse' },
    { id: 116, name: 'Lake Chelan' },
    { id: 117, name: 'Lake Stevens' },
    { id: 118, name: 'Lake Washington' },
    { id: 119, name: 'Lakewood' },
    { id: 120, name: 'Lamont' },
    { id: 121, name: 'Liberty' },
    { id: 122, name: 'Lind' },
    { id: 123, name: 'Longview' },
    { id: 124, name: 'Loon Lake' },
    { id: 125, name: 'Lopez' },
    { id: 126, name: 'Lyle' },
    { id: 127, name: 'Lynden' },
    { id: 128, name: 'Mabton' },
    { id: 129, name: 'Mansfield' },
    { id: 130, name: 'Manson' },
    { id: 131, name: 'Mary M Knight' },
    { id: 132, name: 'Mary Walker' },
    { id: 133, name: 'Marysville' },
    { id: 134, name: 'McCleary' },
    { id: 135, name: 'Mead' },
    { id: 136, name: 'Medical Lake' },
    { id: 137, name: 'Mercer Island' },
    { id: 138, name: 'Meridian' },
    { id: 139, name: 'Methow Valley' },
    { id: 140, name: 'Mill A' },
    { id: 141, name: 'Monroe' },
    { id: 142, name: 'Montesano' },
    { id: 143, name: 'Morton' },
    { id: 144, name: 'Moses Lake' },
    { id: 145, name: 'Mossyrock' },
    { id: 146, name: 'Mount Adams' },
    { id: 147, name: 'Mount Baker' },
    { id: 148, name: 'Mount Pleasant' },
    { id: 149, name: 'Mount Vernon' },
    { id: 150, name: 'Mukilteo' },
    { id: 151, name: 'Naches Valley' },
    { id: 152, name: 'Napavine' },
    { id: 153, name: 'Naselle-Grays River Valley' },
    { id: 154, name: 'Nespelem #14' },
    { id: 155, name: 'Newport' },
    { id: 156, name: 'Nine Mile Falls' },
    { id: 157, name: 'Nooksack Valley' },
    { id: 158, name: 'North Beach' },
    { id: 159, name: 'North Franklin' },
    { id: 160, name: 'North Kitsap' },
    { id: 161, name: 'North Mason' },
    { id: 162, name: 'North River' },
    { id: 163, name: 'North Thurston' },
    { id: 164, name: 'Northport' },
    { id: 165, name: 'Northshore' },
    { id: 166, name: 'Oak Harbor' },
    { id: 167, name: 'Oakesdale' },
    { id: 168, name: 'Oakville' },
    { id: 169, name: 'Ocean Beach' },
    { id: 170, name: 'Ocosta' },
    { id: 171, name: 'Odessa' },
    { id: 172, name: 'Okanogan' },
    { id: 173, name: 'Olympia' },
    { id: 174, name: 'Omak' },
    { id: 175, name: 'Onalaska' },
    { id: 176, name: 'Onion Creek' },
    { id: 177, name: 'Orcas Island' },
    { id: 178, name: 'Orchard Prairie' },
    { id: 179, name: 'Orient' },
    { id: 180, name: 'Orondo' },
    { id: 181, name: 'Oroville' },
    { id: 182, name: 'Orting' },
    { id: 183, name: 'Othello' },
    { id: 184, name: 'Palisades' },
    { id: 185, name: 'Palouse' },
    { id: 186, name: 'Pasco' },
    { id: 187, name: 'Pateros' },
    { id: 188, name: 'Paterson' },
    { id: 189, name: 'Pe Ell' },
    { id: 190, name: 'Peninsula' },
    { id: 191, name: 'Pioneer' },
    { id: 192, name: 'Pomeroy' },
    { id: 193, name: 'Port Angeles' },
    { id: 194, name: 'Port Townsend' },
    { id: 195, name: 'Prescott' },
    { id: 196, name: 'Prosser' },
    { id: 197, name: 'Pullman' },
    { id: 198, name: 'Puyallup' },
    { id: 199, name: 'Queets-Clearwater' },
    { id: 200, name: 'Quilcene' },
    { id: 201, name: 'Quillayute Valley' },
    { id: 202, name: 'Lake Quinault' },
    { id: 203, name: 'Quincy' },
    { id: 204, name: 'Rainier' },
    { id: 205, name: 'Raymond' },
    { id: 206, name: 'Reardan-Edwall' },
    { id: 207, name: 'Renton' },
    { id: 208, name: 'Republic' },
    { id: 209, name: 'Richland' },
    { id: 210, name: 'Ridgefield' },
    { id: 211, name: 'Ritzville' },
    { id: 212, name: 'Riverside' },
    { id: 213, name: 'Riverview' },
    { id: 214, name: 'Rochester' },
    { id: 215, name: 'Roosevelt' },
    { id: 216, name: 'Rosalia' },
    { id: 217, name: 'Royal' },
    { id: 218, name: 'San Juan Island' },
    { id: 219, name: 'Satsop' },
    { id: 220, name: 'Seattle' },
    { id: 221, name: 'Sedro-Woolley' },
    { id: 222, name: 'Selah' },
    { id: 223, name: 'Selkirk' },
    { id: 224, name: 'Sequim' },
    { id: 225, name: 'Shaw Island' },
    { id: 226, name: 'Shelton' },
    { id: 227, name: 'Shoreline' },
    { id: 228, name: 'Skamania' },
    { id: 229, name: 'Skykomish' },
    { id: 230, name: 'Snohomish' },
    { id: 231, name: 'Snoqualmie Valley' },
    { id: 232, name: 'Soap Lake' },
    { id: 233, name: 'South Bend' },
    { id: 234, name: 'Tukwila' },
    { id: 235, name: 'South Kitsap' },
    { id: 236, name: 'South Whidbey' },
    { id: 237, name: 'Southside' },
    { id: 238, name: 'Spokane' },
    { id: 239, name: 'Sprague' },
    { id: 240, name: 'St. John' },
    { id: 241, name: 'Stanwood-Camano' },
    { id: 242, name: 'Star No. 054' },
    { id: 243, name: 'Starbuck' },
    { id: 244, name: 'Stehekin' },
    { id: 245, name: 'Steilacoom Hist.' },
    { id: 246, name: 'Steptoe' },
    { id: 247, name: 'Stevenson-Carson' },
    { id: 248, name: 'Sultan' },
    { id: 249, name: 'Summit Valley' },
    { id: 250, name: 'Sumner' },
    { id: 251, name: 'Sunnyside' },
    { id: 252, name: 'Tacoma' },
    { id: 253, name: 'Taholah' },
    { id: 254, name: 'Tahoma' },
    { id: 255, name: 'Tekoa' },
    { id: 256, name: 'Tenino' },
    { id: 257, name: 'Thorp' },
    { id: 258, name: 'Toledo' },
    { id: 259, name: 'Tonasket' },
    { id: 260, name: 'Toppenish' },
    { id: 261, name: 'Touchet' },
    { id: 262, name: 'Toutle Lake' },
    { id: 263, name: 'Trout Lake' },
    { id: 264, name: 'Tumwater' },
    { id: 265, name: 'Union Gap' },
    { id: 266, name: 'University Place' },
    { id: 267, name: 'Valley' },
    { id: 268, name: 'Vancouver' },
    { id: 269, name: 'Vashon Island' },
    { id: 270, name: 'Wahkiakum' },
    { id: 271, name: 'Wahluke' },
    { id: 272, name: 'Waitsburg' },
    { id: 273, name: 'Walla Walla' },
    { id: 274, name: 'Wapato' },
    { id: 275, name: 'Warden' },
    { id: 276, name: 'Washougal' },
    { id: 277, name: 'Washtucna' },
    { id: 278, name: 'Waterville' },
    { id: 279, name: 'Wellpinit' },
    { id: 280, name: 'Wenatchee' },
    { id: 281, name: 'West Valley (Spokane)' },
    { id: 282, name: 'West Valley (Yakima)' },
    { id: 283, name: 'White Pass' },
    { id: 284, name: 'White River' },
    { id: 285, name: 'White Salmon Valley' },
    { id: 286, name: 'Wilbur' },
    { id: 287, name: 'Willapa Valley' },
    { id: 288, name: 'Wilson Creek' },
    { id: 289, name: 'Winlock' },
    { id: 290, name: 'Wishkah Valley' },
    { id: 291, name: 'Wishram' },
    { id: 292, name: 'Woodland' },
    { id: 293, name: 'Yakima' },
    { id: 294, name: 'Yelm' },
    { id: 295, name: 'Zillah' },
];
exports.schoolDistricts = schoolDistricts;
//# sourceMappingURL=schoolDistricts.js.map